import type { MentionUser } from './MentionNode';

export const mentionName = (user: MentionUser) => `${user.firstName} ${user.lastName}`.trim();

/** The tag a `MentionNode` renders. */
export const MentionChip = ({ user }: { user: MentionUser }) => (
  <span contentEditable={false} className="text-accent-1-100 font-medium">
    @{mentionName(user)}
  </span>
);
